<template>
  <AppView title="重設密碼" :footerShow="true">
    <main
      class="min-h-app bg-gray-50 pb-24 desk:flex desk:min-h-0 desk:flex-1 desk:flex-col desk:bg-white desk:pb-0"
    >
      <div class="desk:grid desk:min-h-0 desk:flex-1 desk:grid-cols-2 desk:items-stretch">
        <section
          class="border-b border-gray-100 bg-white px-5 py-6 desk:flex desk:flex-col desk:justify-start desk:border-b-0 desk:border-r desk:px-8 desk:py-8"
        >
          <p class="text-xs font-medium text-gray-400 desk:text-dove-gray">帳號安全</p>
          <h1 class="mt-2 text-xl font-bold text-gray-900 desk:text-2xl">重設登入密碼</h1>
          <p class="mt-2 text-sm leading-6 text-gray-500 desk:mt-3">
            請輸入會員電話並完成短訊認證，再設定新的登入密碼。
          </p>
          <ul class="mt-8 hidden space-y-7 desk:block">
            <li class="flex items-start gap-3">
              <DeviceMobileIcon class="mt-0.5 h-6 w-6 flex-none text-primary" />
              <div>
                <p class="text-sm font-semibold text-gray-900">短訊認證</p>
                <p class="mt-0.5 text-xs leading-5 text-gray-400">用人機驗證後索取認證碼</p>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <LockClosedIcon class="mt-0.5 h-6 w-6 flex-none text-primary" />
              <div>
                <p class="text-sm font-semibold text-gray-900">設定新密碼</p>
                <p class="mt-0.5 text-xs leading-5 text-gray-400">認證通過後即可重設登入密碼</p>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <LoginIcon class="mt-0.5 h-6 w-6 flex-none text-primary" />
              <div>
                <p class="text-sm font-semibold text-gray-900">返回登入</p>
                <p class="mt-0.5 text-xs leading-5 text-gray-400">重設完成後即可用新密碼登入</p>
              </div>
            </li>
          </ul>
        </section>

        <form
          data-desktop-auth-column
          class="mt-2 border-y border-gray-100 bg-white px-5 py-5 desk:mt-0 desk:flex desk:flex-col desk:justify-start desk:border-0 desk:px-8 desk:py-8"
          @submit.prevent="submit"
        >
          <div class="desk:mx-auto desk:w-full desk:max-w-[400px]">
            <h2 class="mb-5 text-sm font-bold text-gray-900">會員電話</h2>
            <div class="grid grid-cols-5 gap-x-3">
              <FieldWithLabel
                id="country_code"
                class="col-span-2"
                label="區號"
                placeholder="電話區號"
                v-model="form.country_code"
                type="select"
                :disabled="submitting"
                :options="countryCodeOptions"
              />
              <FieldWithLabel
                id="tel"
                class="col-span-3"
                v-model="form.tel"
                label="電話號碼"
                placeholder="聯絡電話"
                :disabled="submitting"
              />
            </div>

            <VerifyTelField
              v-model="form['tel_verify_code']"
              id="tel_verify_code"
              label="短訊認證碼"
              placeholder="短訊認證碼"
              :tel="form.tel"
              :code="form.country_code"
              :authtype="form.type"
              :disabled="submitting"
            />

            <FieldWithLabel
              id="password"
              type="password"
              v-model="form['password']"
              label="新密碼"
              placeholder="請輸入密碼"
              :disabled="submitting"
            />

            <FieldWithLabel
              id="password_confirmation"
              type="password"
              v-model="form['password_confirmation']"
              label="確認新密碼"
              placeholder="請再次輸入密碼"
              :disabled="submitting"
            />

            <button type="submit" class="btn h-12 w-full text-base" :disabled="submitting">
              {{ submitting ? "處理中..." : "確定" }}
            </button>
            <p class="mt-5 text-center text-sm text-primary">
              <nuxt-link
                :to="localePath('/auth/login')"
                class="desk:font-bold desk:hover:underline"
              >返回會員登入</nuxt-link>
            </p>
          </div>
        </form>
      </div>
    </main>
  </AppView>
</template>

<script>
import {
  DeviceMobileIcon,
  LockClosedIcon,
  LoginIcon,
} from "@vue-hero-icons/outline";
import { assertSixDigitOtp } from "@/utils/otp";

export default {
  auth: false,
  components: {
    DeviceMobileIcon,
    LockClosedIcon,
    LoginIcon,
  },
  data() {
    return {
      form: {
        type: "forgot",
        country_code: this.defaultCountryCode,
        tel: "",
      },
      submitting: false,
    };
  },
  methods: {
    async submit() {
      if (this.submitting) return;
      if (!assertSixDigitOtp(this.form.tel_verify_code, (msg) => this.$loader.error(msg))) return;
      try {
        this.submitting = true;
        this.$loader.load();
        await this.$axios.post("/api/forgot", this.form);
        this.$loader.success("密碼已重設");
        this.$router.push("/auth/login");
      } catch (e) {
        console.error(e);
        if (e && e.response) {
          this.handleErrorsMessage(e);
        } else {
          this.$loader.error();
        }
        this.submitting = false;
      }
    },
  },
};
</script>
